import { render, staticRenderFns } from "./AIAnalysis.vue?vue&type=template&id=2f3d2188&scoped=true"
import script from "./AIAnalysis.vue?vue&type=script&lang=js"
export * from "./AIAnalysis.vue?vue&type=script&lang=js"
import style0 from "./AIAnalysis.vue?vue&type=style&index=0&id=2f3d2188&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d2188",
  null
  
)

export default component.exports